import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Like Angelina and Scarlet having sex with your eyes",
  "description": "",
  "published": "2009-12-23T00:00:00.000Z",
  "redirect_from": ["/blog/like-angelina-and-scarlet-having-sex-with-your-eyes/swizec/1024"],
  "categories": "Arts, Fantasy, Film, life, review, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><a parentName="p" {...{
        "href": "http://swizec.com/blog/wp-content/uploads/2009/12/Avatar-Teaser-Poster.jpg"
      }}><img parentName="a" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2009/12/Avatar-Teaser-Poster.jpg",
          "alt": "Avatar-Teaser-Poster",
          "title": "Avatar-Teaser-Poster"
        }}></img></a>{`Last night I watched Avatar nice and proper at the moving pictures - in 3D of course because fuck it, if they spent developing the funky new tech for seven years, I bloody well feel obliged to watch the movie as it was intended.`}</p>
    <p>{`In short ... `}<strong parentName="p">{`it was fucking awesome!`}</strong>{` This is the first movie in `}<em parentName="p">{`15`}</em>{` years that I am willing to pay for again and probably will. Sometime this week. Yep, I've always liked watching movies I like several times in rapid succession - this one however I can't do justice with my rig at home. So the moving pictures it is!`}</p>
    <p>{`Because I want each and everyone of you to go see this masterpiece I will not tell you anything about the story, but here are some tidbits that I believe make it more than just your usual blockbuster effects pornography.`}</p>
    <ol>
      <li parentName="ol">{`There is a very good story that ties the whole movie together, albeit extremely cliche, it still throws a glove at the face of modern culture and blahblah. No story talk!`}</li>
      <li parentName="ol">{`So. Much. Eye-porn! Love love love! It was `}<strong parentName="li">{`like `}<a parentName="strong" {...{
            "href": "http://en.wikipedia.org/wiki/Angelina_Jolie",
            "title": "Angelina Jolie"
          }}>{`Angelina Jolie`}</a>{`, Liz Hurley and `}<a parentName="strong" {...{
            "href": "http://en.wikipedia.org/wiki/Scarlett_Johansson",
            "title": "Scarlett Johansson"
          }}>{`Scarlet Johansson`}</a>{` having sex with my eyes simultaneously for three hours.`}</strong></li>
      <li parentName="ol">{`Very fucking awesome scenography! You know those incredibly artistic comics you see in Flight and other proper art books? Well this was just like that, except in a movie! A fucking movie! I've never seen anything like it before. It was quite beyond words.`}</li>
      <li parentName="ol">{`The details! Oh gawd the details. How often do you see a movie where scenes shot from within a glass canopy of any sort actually show the glass? That's right, none. Until now.`}</li>
      <li parentName="ol">{`The world made sense. This is very rare in fantasy these days, but the world made very much fucking sense. The animals looked `}{`_`}{`right, `}{`_`}{`even the topography and fauna looked proper and correct. It felt like properly exploring a foreign planet, not like somebody was pulling ideas out of their arse.`}</li>
      <li parentName="ol">{`The blue people had a language. Now maybe I'm just a language geek, but it fills me with great delight to see that an artist went through the pain of creating a proper language instead of just stringing random words together ... although it did sound a lot like a derivative of `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Quenya",
          "title": "Quenya"
        }}>{`Quenya`}</a>{`.`}</li>
    </ol>
    <p>{`Now, there were a few annoying little tidbits that felt somewhat ... off.`}</p>
    <p>{`Like for example, if every animal on the world has three limbs, why do the humanoid peoples only have four? Doesn't make sense.`}</p>
    <p>{`Or ... uhm ... why did the animals feel so derivative of Earth animals? You have this wonderful opportunity to create something awesome, and you do, but why the fuck do you make my mind go "Well that's a Rhino equivalent" ... "and that's a dog" ... "oh look, a hyenna" and so forth? Don't `}<em parentName="p">{`do`}</em>{` that. Making animals that are awesomely designed, but then almost neglecting their behaviour ... tsk tsk.`}</p>
    <p>{`All in all, the movie is a definite thumbs up. All f0our thumbs!`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/b5035e2c-5595-4d8b-b23c-8194c6e90a96/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=b5035e2c-5595-4d8b-b23c-8194c6e90a96",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      